export class ConsultaPreviaModel {
  cnpj: number;
  razaoSocial: string;
  cpf: number;
  nome: string;
  dtNascimento: Date;
  documentoTipo: number;
}
